import {
  backend_url,
  uninterceptedAxiosInstance,
} from "../common/commonVariables";

export const createNewProcedure = async (
  title,
  description,
  category,
  fields,
  headers,
  organisation = "",
  createdByUser = null,

  isGlobalTemplate,
  assets
) => {
  try {
    let params = {
      title,
      description,
      category,
      fields,
      headers,
      organisation,
      createdByUser,
      isGlobalTemplate,
      assets,
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "procedures",
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const updateProcedure = async (
  id,
  title,
  description,
  category,
  fields,
  headers,
  assets
) => {
  try {
    let params = {
      title,
      description,
      category,
      fields,
      headers,
      assets,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "procedures/" + id,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const deleteProcedure = async (ID, reason) => {
  try {
    let params = {
      data: [
        {
          id: ID,
          deleteReason: reason,
        },
      ],
    };
    const response = await uninterceptedAxiosInstance.post(
      backend_url + "procedures/removeProcedures",
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};
